import React from "react";

import { CircularProgress, Typography } from "@mui/material";


import { createUseStyles } from "react-jss";

import { useNavigate, useSearchParams } from "react-router-dom";

import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";

import { signOut, signInWithGoogle } from "services/firebase";
import { UserContext } from "services/auth";

import styles from "assets/jss/material-dashboard-pro-react/views/signUpStyle.js";

const useStyles = createUseStyles(styles);

export default function SignUp(props) {
  const navigate = useNavigate();
  const classes = useStyles();
  const { setSnackbar } = props;

  const [user] = React.useContext(UserContext);
  const [loadingCheckout, setLoadingCheckout] = React.useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  React.useEffect(() => {
    const message = searchParams.get("message");
    if (message && user !== undefined) {
      setSnackbar({
        show: true,
        message:
          "A subscription is required to enter the dashboard with an account.",
      });
    }
  }, [searchParams, setSnackbar]);

  const handleExit = () => {
    navigate("/");
  };

  const handleLearnMore = () => {
    navigate("/plans");
  };

  const handleSubscribe = async () => {
    try {
      await signInWithGoogle();
    } catch (e) {
      console.log(e);
      setLoadingCheckout(false);
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <Card className={classes.card}>
          <CardContent>
            <Button
              variant="outlined"
              color="secondary"
              classes={{
                label: classes.buyLabel,
                root: classes.buyRoot,
              }}
              onClick={() => {
                if (!user) {
                  handleSubscribe();
                }
              }}
            >
              {loadingCheckout ? (
                <CircularProgress color="secondary" />
              ) : (
                <>
                  <Typography variant="h6">{user ? "Premium Active" : "Upgrade to Premium (free)"}</Typography>
                </>
              )}
            </Button>

            <Typography
              variant="caption"
              component="p"
              className={classes.terms}
            >
              By subscribing you agree to the{" "}
              <a href="/legal/privacy-policy" target="_blank">
                Privacy Policy
              </a>
            </Typography>
          </CardContent>
          <CardActions classes={{ root: classes.cardActionsRoot }}>
            <Button size="small" onClick={handleLearnMore}>
              Learn More
            </Button>
            <Button color="primary" onClick={handleExit}>
              Exit to home page
            </Button>
          </CardActions>
        </Card>
      </div>
    </div>
  );
}
